<template>
  <v-sheet>
    <div class="accent-block mt-4 mb-4" v-if="afficheAideCreation">
      <p v-if="modification">Veuillez saisir les modifications relatives à votre association.</p>
      <p v-else>Veuillez saisir les informations relatives à l'association.</p>
    </div>
    <v-row dense>
      <v-col cols="12">
        <v-text-field
          filled
          label="Dénomination"
          v-model="denomination"
          :rules="[requiredRule(), serverRule('association.denomination')]"
          @input="notify('association.denomination')"
          data-testid="denomination"
        />
      </v-col>

      <v-col cols="12">
        <v-textarea
          filled
          label="Objet"
          v-model="objet"
          :rules="[requiredRule(), serverRule('association.objet')]"
          @input="notify('association.objet')"
          data-testid="objet"
        />
      </v-col>

      <v-col cols="12" md="6">
        <a-domaine-select
          dense
          filled
          label="Domaine"
          :theme="theme"
          v-model="domaine"
          :rules="[serverRule('association.domaine')]"
          @input="notify('association.domaine')"
          :anciens="anciensDomaines"
          data-testid="domaine"
        />
      </v-col>
      <v-col cols="12" md="6">
        <a-theme-select
          dense
          filled
          label="Thèmes"
          :domaine="domaine"
          v-model="theme"
          :rules="[serverRule('association.theme')]"
          @input="notify('association.theme')"
          data-testid="themes"
        />
      </v-col>

      <v-col cols="12" md="6">
        <a-gouvernance-combobox
          dense
          filled
          label="Représentant légal"
          v-model="gouvernance"
          :rules="[requiredRule(), serverRule('association.gouvernance')]"
          @input="notify('association.gouvernance')"
          data-testid="representant-legal"
        />
      </v-col>
      <v-col cols="12" md="6">
        <a-but-association-switch
          filled
          v-model="but"
          vrai="LUCRATIF"
          faux="NON_LUCRATIF"
          :rules="[serverRule('association.but')]"
          @input="notify('association.but')"
          data-testid="but-association"
        />
      </v-col>
      <v-col cols="6">
        <a-cooperative-select
          filled
          label="Type d'association"
          v-model="cooperative"
          :rules="[serverRule('association.cooperative')]"
          @input="notify('association.cooperative')"
          :disabled="modification"
          data-testid="type-association"
        />
      </v-col>

      <v-col cols="6"> </v-col>

      <v-col cols="12" md="6">
        <a-duree-field
          dense
          filled
          clearable
          label="Durée de l'association"
          v-model="dureeValidite"
          :rules="[serverRule('association.dureeValidite.valeur')]"
          @input="notify('association.dureeValidite.valeur')"
          data-testid="duree-association"
        />
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          dense
          filled
          label="Date de l'expiration de l'association"
          type="date"
          v-model="finValidite"
          :rules="[serverRule('association.finValidite')]"
          @input="notify('association.finValidite')"
          data-testid="date-expiration-association"
        />
      </v-col>
      <v-col cols="12" md="6">
        <a-duree-field
          dense
          filled
          clearable
          label="Fréquence de renouvellement de la direction"
          v-model="dureeRenouvellement"
          :rules="[serverRule('association.dureeRenouvellement.valeur')]"
          @input="notify('association.dureeRenouvellement.valeur')"
          data-testid="frequence-renouvellement-direction"
        />
      </v-col>

      <v-col cols="12">
        <v-divider class="ma-2" />
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          filled
          label="Adresse du siège"
          v-model="adresse.adresse"
          :rules="[requiredRule(), serverRule('association.adresse.adresse')]"
          @input="notify('association.adresse.adresse')"
          data-testid="adresse-siege"
        />
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          filled
          label="Complément d'adresse"
          v-model="adresse.complementAdresse"
          :rules="[serverRule('association.adresse.complementAdresse')]"
          @input="notify('association.adresse.complementAdresse')"
          data-testid="complement-adresse"
        />
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          filled
          label="Code postal"
          v-model="adresse.codePostal"
          :rules="[requiredRule(), serverRule('association.adresse.codePostal')]"
          @input="notify('association.adresse.codePostal')"
          data-testid="code-postal"
        />
      </v-col>
      <v-col cols="12" md="6">
        <a-commune-autocomplete
          filled
          label="Commune du siège"
          v-model="adresse.commune"
          :codePostal="adresse.codePostal"
          :rules="[requiredRule(), serverRule('association.adresse.commune')]"
          @input="notify('association.adresse.commune')"
          :hint="libelleJuridiction"
          :success="!!libelleJuridiction"
          :persistent-hint="!!libelleJuridiction"
          data-testid="commune-siege"
        />
      </v-col>
      <v-col cols="12">
        <v-text-field
          filled
          label="Domiciliation"
          v-model="adresse.domiciliation"
          :rules="[serverRule('association.adresse.domiciliation')]"
          @input="notify('association.adresse.domiciliation')"
          data-testid="domiciliation"
        />
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          dense
          filled
          class="hint-multiligne"
          label="Adresse courriel de l'association"
          v-model.trim="adresseCourriel"
          :rules="[serverRule('association.adresseCourriel')]"
          @input="notify('association.adresseCourriel')"
          hint="En saisissant votre courriel vous consentez à la notification électronique et acceptez d'être recontacté par voie électronique par le tribunal en cas de besoin lié à vos démarches en ligne."
          persistent-hint
          data-testid="adresse-courriel-association"
        />
      </v-col>
      <v-col cols="12"  md="6">
        <v-text-field
          dense
          filled
          label="Adresse du site internet de l'association"
          v-model="adresseSite"
          :rules="[serverRule('association.adresseSite')]"
          @input="notify('association.adresseSite')"
          data-testid="adresse-site-association"
        />
      </v-col>
      <v-col cols="12" md="6"> </v-col>
      <v-col cols="12">
        <v-checkbox
          v-model="stipulations"
          label="Restrictions de l'étendue du pouvoir de représentation de la direction ou dérogeant aux règles de l'article 28 alinéa 1 relatives au pouvoir de la  direction"
          :rules="[serverRule('association.stipulations')]"
          @change="notify('association.stipulations')"
          data-testid="stipulations"
        />
      </v-col>
      <v-col cols="12">
        <v-textarea
          v-if="stipulations"
          component="v-textarea"
          dense
          filled
          label="Précision sur les stipulations"
          v-model="precisionStipulation"
          :rules="[requiredRule(), serverRule('association.precisionStipulation')]"
          @input="notify('association.precisionStipulation')"
          data-testid="precision-stipulation"
        />
      </v-col>
    </v-row>
  </v-sheet>
</template>

<script>
import makeValueData from "@/mixins/makeValueData";
import makeRules from "@/mixins/makeRules";
import ValueDataRules from "@/mixins/ValueDataRules";
import DepotMixin from "./DepotMixin";

function mapTo(src, dest) {
  src = src || {};
  const adresse = src.adresse || {};
  const dureeValidite = src.dureeValidite || {};
  const dureeRenouvellement = src.dureeRenouvellement || {};

  dest.denomination = src.denomination;
  dest.but = src.but || "NON_LUCRATIF";
  dest.gouvernance = src.gouvernance;
  dest.objet = src.objet;
  dest.domaine = src.domaine;
  dest.theme = src.theme;
  dest.cooperative = src.cooperative || false;
  dest.finValidite = src.finValidite;
  dest.dureeValidite = src.dureeValidite;
  dest.dureeRenouvellement = src.dureeRenouvellement;
  dest.adresseCourriel = src.adresseCourriel;
  dest.adresseSite = src.adresseSite;
  dest.consentementCommunication = src.consentementCommunication;
  dest.stipulations = src.stipulations || false;
  dest.precisionStipulation = src.stipulations ? src.precisionStipulation : null;

  dest.dureeValidite = {
    valeur: dureeValidite.valeur,
    unite: dureeValidite.unite || "JOUR",
  };
  dest.dureeRenouvellement = {
    valeur: dureeRenouvellement.valeur,
    unite: dureeRenouvellement.unite || "JOUR",
  };
  dest.adresse = {
    codePostal: adresse.codePostal,
    commune: adresse.commune,
    adresse: adresse.adresse,
    complementAdresse: adresse.complementAdresse,
    pays: adresse.pays,
    domiciliation: adresse.domiciliation,
  };
}

export default {
  mixins: [DepotMixin, makeValueData(mapTo), makeRules(), ValueDataRules],
  props: {
    modification: {
      type: Boolean,
      default: false,
    },
    anciensDomaines: {
      type: Array,
      default: () => [],
    },
    libelleJuridiction: {
      type: String,
      default: null,
    },
  },
  mounted() {
    this.syncConsentementCommunication();
  },
  computed: {
    communeAdresse() {
      return this.adresse?.commune;
    },
  },
  methods: {
    syncConsentementCommunication() {
      this.consentementCommunication = "" !== (this.adresseCourriel || "").trim();
    },
  },
  watch: {
    adresseCourriel() {
      this.syncConsentementCommunication();
      this.changed();
    },
    communeAdresse(ancien, nouveau) {
      if (ancien?.id === nouveau?.id) return;

      const code = this.adresse?.codePostal || "";
      if (this.communeAdresse?.codePostaux?.length) {
        const match = this.communeAdresse.codePostaux.find(cp => cp.startsWith(code));
        if (match) {
          this.adresse.codePostal = match;
          this.changed();
        }
      }
    },
  },
};
</script>
